module.exports = __webpack_public_path__ + "img/inst-8.f7af0f3e.png";